import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import CardNetworks from '../../_common/cardNetworks.mdx';
import PossibleTypes from './onCardMetadataChangePossibleTypes.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Called when card network information is being fetched from Primer's servers.`}<br parentName="p"></br>{`
`}{`Will only trigger when `}<inlineCode parentName="p">{`event.source === 'REMOTE'`}</inlineCode>{` in `}<inlineCode parentName="p">{`onCardNetworksChange`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      